import _readOnlyError from "@babel/runtime/helpers/esm/readOnlyError";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TagWrapper from '../TagWrapper';
import differenceBy from 'lodash/differenceBy';
import t from '@instructure/quiz-i18n/format-message';
import { SELECT_EMPTY_OPTION, Select } from '@instructure/quiz-common';
var tagShape = PropTypes.shape({
  id: PropTypes.string,
  value: PropTypes.string.isRequired
});
export var TagSelect = /*#__PURE__*/function (_Component) {
  function TagSelect() {
    var _this2;
    _classCallCheck(this, TagSelect);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, TagSelect, [].concat(args));
    _defineProperty(_this2, "state", {
      inputValue: '',
      isShowingOptions: false,
      highlightedOptionId: null
    });
    _defineProperty(_this2, "setInputRef", function (inputRef) {
      _this2.inputRef = inputRef;
    });
    _defineProperty(_this2, "handleShowOptions", function () {
      _this2.setState({
        isShowingOptions: true
      });
    });
    _defineProperty(_this2, "handleHideOptions", function () {
      _this2.setState({
        isShowingOptions: false
      });
    });
    _defineProperty(_this2, "handleBlur", function () {
      _this2.setState({
        highlightedOptionId: null
      });
    });
    _defineProperty(_this2, "handleHighlightOption", function (event, _ref) {
      var id = _ref.id;
      event.persist();
      var tag = _this2.decodeTag(id);
      _this2.setState(function (state) {
        return {
          highlightedOptionId: id,
          inputValue: event.type === 'keydown' ? tag.value : state.inputValue
        };
      });
    });
    _defineProperty(_this2, "handleSelectOption", function (event, _ref2) {
      var id = _ref2.id;
      if (id === SELECT_EMPTY_OPTION) return;
      var tag = _this2.decodeTag(id);
      _this2.props.onChange([].concat(_toConsumableArray(_this2.props.tags), [tag.id ? tag : {
        value: tag.value
      }]));
      _this2.setState({
        highlightedOptionId: null,
        inputValue: '',
        isShowingOptions: false
      });
    });
    _defineProperty(_this2, "handleInputChange", function (event) {
      var inputValue = event.target.value !== ' ' ? event.target.value : '';
      _this2.props.onInputChange(inputValue === '' ? null : inputValue);
      _this2.setState({
        inputValue: inputValue,
        isShowingOptions: true
      });
    });
    _defineProperty(_this2, "handleKeyDown", function (event) {
      var inputValue = _this2.state.inputValue;
      if (event.keyCode === 8) {
        // when backspace key is pressed
        if (inputValue === '' && _this2.props.tags.length > 0) {
          // remove last selected option, if input has no entered text
          _this2.props.onChange(_this2.props.tags.slice(0, -1));
          _this2.setState({
            highlightedOptionId: null
          });
        }
      }
    });
    _defineProperty(_this2, "dismissTag", function (encodedTag) {
      var tags = _this2.props.tags.filter(function (tag) {
        return _this2.encodeTag(tag) !== encodedTag;
      });
      _this2.props.onChange(tags);
      _this2.setState({
        highlightedOptionId: null
      }, function () {
        _this2.inputRef.focus();
      });
    });
    return _this2;
  }
  _inherits(TagSelect, _Component);
  return _createClass(TagSelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.tagSuggestions !== this.props.tagSuggestions) {
        this.setState({
          highlightedOptionId: this.props.tagSuggestions.length > 0 ? this.encodeTag(this.props.tagSuggestions[0]) : null
        });
      }
    }
  }, {
    key: "encodeTag",
    value: function encodeTag(tag) {
      return String(tag.id) + ' ' + tag.value;
    }
  }, {
    key: "decodeTag",
    value: function decodeTag(encodedTag) {
      var parts = encodedTag.split(' ');
      var id = parts.shift();
      return {
        id: id !== 'undefined' ? id : undefined,
        value: parts.join(' ')
      };
    }
  }, {
    key: "normalizeSpaces",
    value: function normalizeSpaces(text) {
      return text.replace(/  +/g, ' ').trim();
    }
  }, {
    key: "renderTags",
    value: function renderTags() {
      var _this3 = this;
      var tags = this.props.tags;
      return tags.map(function (tag, index) {
        return /*#__PURE__*/React.createElement(TagWrapper, {
          key: _this3.encodeTag(tag),
          id: _this3.encodeTag(tag),
          index: index,
          text: tag.value,
          onClick: _this3.dismissTag
        });
      });
    }
  }, {
    key: "emptyOption",
    value: function emptyOption() {
      var _this$props = this.props,
        tags = _this$props.tags,
        noMatchText = _this$props.noMatchText;
      var inputValue = this.normalizeSpaces(this.state.inputValue);
      var exists = t('Tag already selected: { text }', {
        text: inputValue
      });
      return tags.some(function (tag) {
        return tag.value === inputValue;
      }) ? exists : noMatchText;
    }
  }, {
    key: "options",
    value: function options() {
      var _this4 = this;
      var _this$props2 = this.props,
        allowNewTags = _this$props2.allowNewTags,
        tags = _this$props2.tags,
        tagSuggestions = _this$props2.tagSuggestions;
      var notSelectedTagSuggestions = differenceBy(tagSuggestions, tags, 'value');
      var options = notSelectedTagSuggestions.map(function (tag) {
        return /*#__PURE__*/React.createElement(Select.Option, {
          key: _this4.encodeTag(tag),
          id: _this4.encodeTag(tag),
          isHighlighted: _this4.encodeTag(tag) === _this4.state.highlightedOptionId
        }, tag.value);
      });
      var inputValue = this.normalizeSpaces(this.state.inputValue);
      // Don't offer tag creation on suggested or selected tags
      if (!tagSuggestions.concat(tags).some(function (tag) {
        return tag.value === inputValue;
      })) {
        if (allowNewTags && inputValue.length > 0) {
          options.push(/*#__PURE__*/React.createElement(Select.Option, {
            id: this.encodeTag({
              value: inputValue
            }),
            key: this.encodeTag({
              value: inputValue
            }),
            isHighlighted: options.length === 0
          }, t('Create new tag: { text }', {
            text: inputValue
          })));
        }
      }
      if (options.length === 0) {
        options.push(/*#__PURE__*/React.createElement(Select.Option, {
          id: SELECT_EMPTY_OPTION,
          key: SELECT_EMPTY_OPTION
        }, this.emptyOption()));
      }
      return options;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        inputValue = _this$state.inputValue,
        isShowingOptions = _this$state.isShowingOptions;
      return /*#__PURE__*/React.createElement(Select, {
        renderLabel: t('Tags and Metadata'),
        inputValue: inputValue,
        isShowingOptions: isShowingOptions,
        inputRef: this.setInputRef,
        onBlur: this.handleBlur,
        onInputChange: this.handleInputChange,
        onRequestShowOptions: this.handleShowOptions,
        onRequestHideOptions: this.handleHideOptions,
        onRequestHighlightOption: this.handleHighlightOption,
        onRequestSelectOption: this.handleSelectOption,
        onKeyDown: this.handleKeyDown,
        renderBeforeInput: this.props.tags.length > 0 ? this.renderTags() : null,
        "data-automation": "sdk-tags-and-metadata"
      }, this.options());
    }
  }]);
}(Component);
_defineProperty(TagSelect, "propTypes", {
  allowNewTags: PropTypes.bool,
  noMatchText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  tagSuggestions: PropTypes.arrayOf(tagShape),
  tags: PropTypes.arrayOf(tagShape)
});
_defineProperty(TagSelect, "defaultProps", {
  allowNewTags: true,
  tags: [],
  tagSuggestions: []
});
export default TagSelect;